import styled, { css } from "styled-components"
import {
  desktopTextStyles,
  mobileTextStyles,
} from "../shared/typography.styles"
import Breakpoints from "../shared/breakpoints"
import Img from "gatsby-image"
import { FadeIn, FadeInBottom } from "../shared/keyframes.style"

export const PlatformBlocks = styled(Img)`
  display: none;
  @media (min-width: ${Breakpoints.md}) {
    z-index: 100;
    display: block;
    grid-column: 5 / 9;
    grid-row: 1 / 5;
    max-width: 100%;
    align-self: start;
  }

  animation: ${props => !props.disableAnimations && FadeIn};
  animation-duration: 1.5s;
  animation-timing-function: ease;
  animation-delay: 0s;
  animation-fill-mode: both;
  animation-play-state: ${props => (props.isVisible ? "running" : "paused")};
`
export const Title = styled.p`
  ${mobileTextStyles.MobileHeadingTwoRegular}
  width: 100%;
  text-align: left;
  z-index: 110;
  grid-column: 1 / -1;
  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
    text-align: center;
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${desktopTextStyles.HeadingTwoRegular}
    grid-column:  3 / 11;
    grid-row: 4;
  }

  color: var(--slate);

  & > span {
    font-weight: 500;
    color: var(--burnt-orange);
  }

  animation: ${props => !props.disableAnimations && FadeInBottom};
  animation-duration: 1.5s;
  animation-timing-function: ease;
  animation-delay: 0.4s;
  animation-fill-mode: both;
  animation-play-state: ${props => (props.isVisible ? "running" : "paused")};
`

export const TitleDescription = styled.p`
  
  text-align: center;
  color: var(--body-text-grey);
  grid-column:  1 / -1;
  text-align: left;
  margin-top: 32px;

  ${mobileTextStyles.MobileBodyRegular}

  @media (min-width: ${Breakpoints.md}) {
    ${desktopTextStyles.BodyText16}
    text-align: center;
    grid-column:  3 / -3;
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${desktopTextStyles.BodyText18}
  }

  
  animation: ${props => !props.disableAnimations && FadeIn};
  animation-duration: 1.5s;
  animation-timing-function: ease;
  animation-delay: 0.8s;
  animation-fill-mode: both;
  animation-play-state: ${props => (props.isVisible ? "running" : "paused")};

`

export const LinkContainer = styled.div`
  display: grid;
  grid-gap: 20px;
  margin-top: 48px;
  grid-column: 2 / 12;
  grid-template-columns: 1fr;

  @media (min-width: ${Breakpoints.md}) {
    grid-template-columns: 1fr 1fr;

    & > *:first-child {
      justify-self: end;
    }
  }

  animation: ${props => !props.disableAnimations && FadeIn};
  animation-duration: 1.5s;
  animation-timing-function: ease;
  animation-delay: 0.4s;
  animation-fill-mode: both;
  animation-play-state: ${props => (props.isVisible ? "running" : "paused")};
`

export const LinkStyle = css`
  @media (min-width: ${Breakpoints.md}) {
    max-width: 282px;
    width: 100%;
  }
`

export const OutlineLinkStyle = css`
  ${LinkStyle}

  background: none;
  border: 1px solid var(--burnt-orange);
  color: var(--burnt-orange);
`
